module.exports = __webpack_public_path__ + "img/icon-pag-boleto.dcd5bd7e.png";